module.exports = __webpack_public_path__ + "static/img/case4-bg.a478108.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/business/case4-bg.png
// module id = y6zo
// module chunks = 0